/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @version 1.3.2
 * @since 1.0.1
 */

import styled from 'styled-components';

import { WidgetBlockStyled } from '../../styled/WidgetContainerStyled';

export const WidgetSubscriberMobileStyled: any = styled(WidgetBlockStyled).attrs({
    className: 'widget__widget-subscriber-mobile',
})`
    display: flex;
    flex-direction: column;
    min-height: 348px;
`;
